import Modal from 'react-modal';
import * as S from '../styles';
import { useRouter } from 'next/router';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { toast } from 'react-toastify';
import jwt from 'jwt-decode';

import { Auth } from 'aws-amplify';
import { ToastIcon } from '@/components/global/ToastIcon';
import { MdOutlineEmail } from 'react-icons/md';
import { RiLockPasswordFill } from 'react-icons/ri';

type LoginFormData = {
  email: string;
  password: string;
};

type Token = {
  sub: string;
  'cognito:groups': string[];
};

type ModalWithEmailProps = {
  onClose: () => void;
};

const LoginFormValidation = yup.object().shape({
  email: yup.string().email().required('Informe seu e-mail'),
  password: yup.string().required('Informe sua senha'),
});

export function ModalWithEmail({ onClose }: ModalWithEmailProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const router = useRouter();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormData>({
    resolver: yupResolver(LoginFormValidation),
  });

  async function submit({ password, email }: LoginFormData) {
    try {
      setIsLoading(true);

      const response = await Auth.signIn({
        password,
        username: email,
      });

      const token: Token = jwt(response.signInUserSession.idToken.jwtToken);

      const group = token['cognito:groups'][0];

      if (group !== 'admin') {
        throw new Error('Just Admin can be access');
      }

      router.push('/escolas');
    } catch (err) {
      toast.error(<strong>E-Mail ou senha inválido</strong>, {
        icon: <ToastIcon type="error" />,
      });
      setIsLoading(false);
    }
  }

  return (
    <Modal
      isOpen={true}
      contentLabel="Login With Email"
      style={{
        content: {
          background: '#2C0E80',
          border: '1px solid #AEA0E8',
          maxWidth: '450px',
          height: '300px',
          width: '100%',
        },
      }}
    >
      <S.ModalForm onSubmit={handleSubmit(submit)}>
        <div>
          <S.InputGroup>
            <MdOutlineEmail color="#fff" size={30} />
            <input
              type="email"
              {...register('email')}
              disabled={isLoading}
              placeholder="Digite seu E-Mail"
            />
          </S.InputGroup>
          {!!errors.email?.message && <strong>{errors.email.message}</strong>}
        </div>
        <div>
          <S.InputGroup>
            <RiLockPasswordFill size={30} color="#fff" />
            <input
              type="password"
              {...register('password')}
              disabled={isLoading}
              placeholder="Digite sua senha"
            />
          </S.InputGroup>
          {!!errors.password?.message && (
            <strong>{errors.password.message}</strong>
          )}
        </div>
        <S.ModalFormFooter isLoading={isLoading}>
          {!isLoading && (
            <button type="button" onClick={onClose}>
              Cancelar
            </button>
          )}
          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Carregando' : 'Entrar'}
          </button>
        </S.ModalFormFooter>
      </S.ModalForm>
    </Modal>
  );
}
